import { render, staticRenderFns } from "./Loaders.vue?vue&type=template&id=0d00dac0&"
import script from "./Loaders.vue?vue&type=script&lang=js&"
export * from "./Loaders.vue?vue&type=script&lang=js&"
import style0 from "./Loaders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports